var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "drag-dialog",
        _vm._g(
          _vm._b(
            {
              staticClass: "gl-new-dialogPop ",
              attrs: {
                title: _vm.$t("blExchangeAppointment.accredit"),
                isShowFollow: false,
              },
              on: { open: _vm.opened },
            },
            "drag-dialog",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [
          _c("div", { staticClass: "panel-body" }, [
            _c(
              "div",
              { staticClass: "filter-container-content" },
              [
                _c("el-form", { ref: "form", attrs: { model: _vm.form } }, [
                  _c(
                    "table",
                    {
                      staticClass: "mailTable",
                      staticStyle: { width: "100%", "margin-bottom": "0" },
                    },
                    [
                      _c("colgroup", [
                        _c("col", { attrs: { width: "100px" } }),
                        _vm._v(" "),
                        _c("col", { attrs: { width: "100px" } }),
                        _vm._v(" "),
                        _c("col", { attrs: { width: "100px" } }),
                        _vm._v(" "),
                        _c("col", { attrs: { width: "100px" } }),
                        _vm._v(" "),
                        _c("col", { attrs: { width: "100px" } }),
                        _vm._v(" "),
                        _c("col", { attrs: { width: "100px" } }),
                        _vm._v(" "),
                        _c("col", { attrs: { width: "100px" } }),
                        _vm._v(" "),
                        _c("col", { attrs: { width: "100px" } }),
                        _vm._v(" "),
                        _c("col", { attrs: { width: "100px" } }),
                        _vm._v(" "),
                        _c("col", { attrs: { width: "100px" } }),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c(
                          "td",
                          { staticClass: "column", attrs: { colspan: "5" } },
                          [
                            _c("span", { staticClass: "column-after" }, [
                              _vm._v(
                                _vm._s(_vm.$t("blExchangeAppointment.blNo"))
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { prop: "accreditBlNo" } },
                              [
                                _c("el-input", {
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.form.accreditBlNo,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "accreditBlNo", $$v)
                                    },
                                    expression: "form.accreditBlNo",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "column", attrs: { colspan: "5" } },
                          [
                            _c("span", { staticClass: "column-after" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "blExchangeAppointment.accreditCustomer"
                                  )
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { prop: "cstName" } },
                              [
                                _c("gl-customer-sipg", {
                                  on: { change: _vm.selectSipgCstCodeChange },
                                  model: {
                                    value: _vm.form.cstName,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "cstName", $$v)
                                    },
                                    expression: "form.cstName",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.displayType
                        ? _c("tr", [
                            _c(
                              "td",
                              {
                                staticClass: "column",
                                attrs: { colspan: "5" },
                              },
                              [
                                _c("span", { staticClass: "column-after" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "blExchangeAppointment.forespeakStatus"
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "forespeakStatus" } },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          disabled: true,
                                          placeholder: _vm.$t(
                                            "blExchangeAppointment.select"
                                          ),
                                        },
                                        model: {
                                          value: _vm.form.forespeakStatus,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "forespeakStatus",
                                              $$v
                                            )
                                          },
                                          expression: "form.forespeakStatus",
                                        },
                                      },
                                      _vm._l(
                                        _vm.forespeakStatusList,
                                        function (item) {
                                          return _c("el-option", {
                                            key: item.codeValue,
                                            attrs: {
                                              value: Number(item.codeValue),
                                              label:
                                                _vm.language === "zh"
                                                  ? item.displayValueCn
                                                  : item.displayValue,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "column ",
                                attrs: { colspan: "5" },
                              },
                              [
                                _c("span", { staticClass: "column-after" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "blExchangeAppointment.accreditStatus"
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "accreditStatus" } },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          disabled: true,
                                          placeholder: _vm.$t(
                                            "blExchangeAppointment.select"
                                          ),
                                        },
                                        model: {
                                          value: _vm.form.accreditStatus,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "accreditStatus",
                                              $$v
                                            )
                                          },
                                          expression: "form.accreditStatus",
                                        },
                                      },
                                      _vm._l(
                                        _vm.accreditStatusList,
                                        function (item) {
                                          return _c("el-option", {
                                            key: item.value,
                                            attrs: {
                                              label:
                                                _vm.language === "zh"
                                                  ? item.labelZh
                                                  : item.labelEn,
                                              value: item.value,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "p-color" }, [
                    _c("p", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t("blExchangeAppointment.authorizationNote")
                        ),
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "item-button" },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "btn-info-primary",
                          on: { click: _vm.handleClose },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("btn.close")) +
                              "\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticClass: "btn-info-primary",
                          on: { click: _vm.handleCancel },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("btn.cancelAccredit")) +
                              "\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticClass: "btn-primary",
                          on: { click: _vm.handleSave },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("btn.accreditSave")) +
                              "\n            "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }